/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureActionGroupDetails {
    getFixupPrototypeFunction() { return AzureActionGroupDetails.fixupPrototype; }

    static newInstance(model: Partial<AzureActionGroupDetails>): AzureActionGroupDetails {
        let obj = Object.assign(new AzureActionGroupDetails(), model);
        AzureActionGroupDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureActionGroupDetails>): AzureActionGroupDetails {
        if (!model) return null;
        return AzureActionGroupDetails.newInstance(<AzureActionGroupDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureActionGroupDetails) {
        if (!obj) return;

        models.AzureActionGroupDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureActionGroupDetails): boolean {
        Object.setPrototypeOf(obj, AzureActionGroupDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Action Group Name
     */
    name: string;

    /**
     * Resource Group Name
     */
    resource_group: string;

}
